import { render, staticRenderFns } from "./deptdetail.vue?vue&type=template&id=5e0ff3e6&"
import script from "./deptdetail.vue?vue&type=script&lang=js&"
export * from "./deptdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports